export const publishGiftboxAddEvent = (params)=>{
    try {
        var _Shopify_analytics;
        const { product , variant  } = params || {};
        const sku = variant === null || variant === void 0 ? void 0 : variant.sku;
        const productTitle = product === null || product === void 0 ? void 0 : product.title;
        const variantTitle = variant === null || variant === void 0 ? void 0 : variant.title;
        const variantPrice = variant === null || variant === void 0 ? void 0 : variant.price;
        const productType = product === null || product === void 0 ? void 0 : product.type;
        const isCartPage = document.body.getAttribute('data-shopify-template') === 'cart';
        const eventSource = isCartPage ? 'cart_page' : 'mini_cart';
        if (typeof (Shopify === null || Shopify === void 0 ? void 0 : (_Shopify_analytics = Shopify.analytics) === null || _Shopify_analytics === void 0 ? void 0 : _Shopify_analytics.publish) === 'function') {
            Shopify.analytics.publish('add_to_cart', {
                event: 'Add to Cart',
                productsToAdd: [
                    {
                        sku: sku,
                        name: productTitle,
                        variantName: variantTitle,
                        price: variantPrice,
                        quantity: 1,
                        productType: productType
                    }
                ],
                source: eventSource
            });
        }
    } catch (err) {
    // swallow analytics errors — non-critical
    }
};
export const publishGiftboxRemoveEvent = (cartItem)=>{
    try {
        var _Shopify_analytics;
        const sku = cartItem === null || cartItem === void 0 ? void 0 : cartItem.sku;
        const productTitle = cartItem === null || cartItem === void 0 ? void 0 : cartItem.title;
        const variantTitle = cartItem === null || cartItem === void 0 ? void 0 : cartItem.variant_title;
        const variantPrice = cartItem === null || cartItem === void 0 ? void 0 : cartItem.price;
        const productType = cartItem === null || cartItem === void 0 ? void 0 : cartItem.product_type;
        const isCartPage = document.body.getAttribute('data-shopify-template') === 'cart';
        const eventSource = isCartPage ? 'cart_page' : 'mini_cart';
        if (typeof (Shopify === null || Shopify === void 0 ? void 0 : (_Shopify_analytics = Shopify.analytics) === null || _Shopify_analytics === void 0 ? void 0 : _Shopify_analytics.publish) === 'function') {
            Shopify.analytics.publish('remove_from_cart', {
                event: 'Remove from Cart',
                productsToRemove: [
                    {
                        sku: sku,
                        name: productTitle,
                        variantName: variantTitle,
                        price: variantPrice,
                        quantity: 1,
                        productType: productType
                    }
                ],
                source: eventSource
            });
        }
    } catch (err) {
    // swallow analytics errors — non-critical
    }
};
